<div id="serviceLogSearch">

  <div class="row">
    <div class="col-12">
      <h1>Service Log</h1>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="urlSearchField">URL</label>
        <input type="text" name="url" id="urlSearchField" (keypress)="searchInputKeyPress($event)"
               class="form-control" [value]="url"
               (input)="url = $event.target.value"
               (keyup.enter)="searchLogs()">
      </div>
      <p *ngIf="allowSearchText(url)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
    </div>
    
    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="requestSearchField">Request</label>
        <input type="text" name="request" id="requestSearchField" (keypress)="searchInputKeyPress($event)"
               class="form-control" [value]="request"
               (input)="request = $event.target.value"
               (keyup.enter)="searchLogs()">
      </div>
      <p *ngIf="allowSearchText(url)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
    </div>
    
    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="responseSearchField">Response</label>
        <input type="text" name="response" id="responseSearchField" (keypress)="searchInputKeyPress($event)"
               class="form-control" [value]="response"
               (input)="response = $event.target.value"
               (keyup.enter)="searchLogs()">
      </div>
      <p *ngIf="allowSearchText(url)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
    </div>
    
    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="traceId">Trace ID</label>
        <input type="text" name="traceId" id="traceId" (keypress)="searchInputKeyPress($event)"
               class="form-control" [value]="traceId"
               (input)="traceId = $event.target.value"
               (keyup.enter)="searchLogs()">
      </div>
    </div>

    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="duration">Duration</label>
        <input type="text" name="duration" id="duration" (keypress)="searchInputKeyPress($event)"
               class="form-control" [value]="duration"
               (input)="duration = $event.target.value"
               (keyup.enter)="searchLogs()">
      </div>
      <p *ngIf="allowSearchText(url)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
    </div>
    
    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="dateRange">Date Range</label>
    		<div class="has-feedback datepicker-control">
    			<input type="text" class="form-control" placeholder="yyyy-mm-dd"  name="dateRange" id="dateRange" />
    			<div class="form-control-feedback"></div>
    		</div>
      </div>
    </div>

    <div class="col-12 col-sm-4">
      <div class="form-group">
        <label for="statusCodes">Status Code</label>
        <div ngbDropdown>
          <button class="btn btn-default" id="statusCodes" ngbDropdownToggle>{{selectedStatusFilter}}</button>
          <div ngbDropdownMenu aria-labelledby="statusCodes" id="statusCodes">
            <a href="javascript:" class="dropdown-item" *ngFor="let statusFilter of statusFilterOptions" (click)="listLogsByStatusCode(statusFilter)" >{{statusFilter}}</a>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <div class="form-group">
        <button [disabled]="loading || !validateSearchText()" class="btn btn-primary" type="button"
                (click)="searchLogs()">Search
        </button>
      </div>
    </div>
  </div>

  <div class="row mt-1" id="logDetailsWrapper">
    <div class="col-12 col-sm-6">
      <h3>Search Results</h3>
    </div>
    <div class="col-12">
      <table class="table table-bordered table-striped" id="serviceLogList" style="width:100%">
      </table>
    </div>
  </div>

  <div class="spinner" *ngIf="loading">
    <div class="lspinner"></div>
  </div>

</div>